import { Resource } from 'i18next';

import enCustomer from './en/customer.json';
import enProduct from './en/product.json';
import enChats from './en/chats.json';
import enErrors from './en/errors.json';
import enMobileApp from './en/mobile-app.json';

import hiChats from './hi/chats.json';
import hiErrors from './hi/errors.json';
import hiMobileApp from './hi/mobile-app.json';

export const i18nResources: Resource = {
  en: {
    customer: enCustomer,
    product: enProduct,
    chats: enChats,
    errors: enErrors,
    mobileApp: enMobileApp,
  },
  hi: {
    chats: hiChats,
    errors: hiErrors,
    mobileApp: hiMobileApp,
  },
};

export const i18nNamespaces = [
  'customer',
  'product',
  'chats',
  'errors',
  'mobileApp',
] as const;

export type I18nNamespace = (typeof i18nNamespaces)[number];

export type CustomerTranslationKeys = keyof typeof enCustomer;
export type ProductTranslationKeys = keyof typeof enProduct;
export type ChatsTranslationKeys = keyof typeof enChats;
export type ErrorsTranslationKeys = keyof typeof enErrors;
export type MobileAppTranslationKeys = keyof typeof enMobileApp;
